import { useEffect, useState, useContext } from 'react';

import { PortalContext } from '../Portal';

/**
 * Хук для получения элемента из shadow DOM по его id, если компонент находится внутри контейнера.
 *
 * @param {string} id - id элемента, который необходимо найти внутри shadow DOM.
 * @returns {HTMLElement | null} - Найденный элемент внутри shadow DOM или null, если элемент не найден.
 */

export const useShadowRootElement = (id?: string) => {
  const [element, setElement] = useState<HTMLElement | null>(null);

  const portalContext = useContext(PortalContext);
  const rootId = portalContext?.widgetContainerId;
  const elementId = id || portalContext?.widgetLayoutContainer;

  useEffect(() => {
    if (!elementId || !rootId) return;

    const shadowRootWrapper = document.getElementById(rootId);
    const root = shadowRootWrapper?.shadowRoot;

    const elementInShadow = root?.getElementById(elementId);

    if (elementInShadow) {
      setElement(elementInShadow);
    }
  }, [elementId, rootId]);

  return element;
};
